// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"Controls_ellipsis__2Mp2b","control":"Controls_control__3rN_j","controlsList":"Controls_controlsList__3Rkxs"};